import React, { useState } from "react";
import { RJSFSchema, UiSchema } from '@rjsf/utils';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';

function CustomSchemaTemplate({ opened, description, secret, when, schema }) {

  let uiSchema = schema.uiSchema;
  let schemaMain = schema.main;

  function MoveUpButton(props) {
    return (<></>);
  }

  function MoveDownButton(props) {
    return (<></>);
  }

  function RemoveButton(props) {
    return (<></>);
  }

  function AddButton(props) {
    return (<></>);
  }
  
  /**
   * Add default values if exists to form recursively in case of nested form elements
   */
  function traverseJSON(jsonObject, values) {
    if (typeof jsonObject === 'object') {
      for (var key in jsonObject) {
        if (jsonObject.hasOwnProperty(key)) {
          if(values[key]){
            jsonObject[key]['default'] = values[key];
          }
          traverseJSON(jsonObject[key], values);
        }
      }
    }
  }

  traverseJSON(schemaMain, secret);

  function traverseFormat(jsonObject) {
    if (typeof jsonObject === 'object') {
      for (var key in jsonObject) {
        if (jsonObject.hasOwnProperty(key)) {
          if(jsonObject[key]['ui:widget']){
            
            switch(jsonObject[key]['ui:widget']){
              case "IpFullInputWidget":
              case "IpInputWidget":
                delete jsonObject[key]['ui:widget'];
              break;
            }
          }
          traverseFormat(jsonObject[key]);
        }
      }
    }
  }

  traverseFormat(uiSchema);

  const [textToCopy, setTextToCopy] = useState(JSON.stringify(secret));
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnCopyContent, setBtnCopyContent] = useState(
    <>
      <i className="fas fa-copy"></i> Copy
    </>
  );
  const [btnRevealContent, setBtnRevealContent] = useState(
    <>
      <i className="fas fa-eye"></i> Reveal
    </>
  );
  const [contentRevealed, setContentRevealed] = useState(false);

  function revealData() {
    setContentRevealed(!contentRevealed);
    if (contentRevealed == false) {
      setBtnRevealContent(
        <>
          <i className="fas fa-eye-slash"></i> Hide
        </>
      );
    } else {
      setBtnRevealContent(
        <>
          <i className="fas fa-eye"></i> Reveal
        </>
      );
    }
  }

  function copyToClipboard() {
    navigator.clipboard.writeText(textToCopy);
    setBtnDisabled(true);

    /* Alert the copied text */
    setBtnCopyContent("Copied!");

    setTimeout(function () {
      setBtnDisabled(false);
      setBtnCopyContent(
        <>
          <i className="fas fa-copy"></i> Copy
        </>
      );
    }, 3000);
  }

  let whenBlock = "";
  let warningBlock = "";

  if (when === false) {
    whenBlock = "";
  } else if (when) {
    whenBlock = (
      <div className="mt-3 mb-3">
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-exclamation-triangle"></i> This link will be
          deleted automatically {when}, save its content in a secure place.
        </div>
      </div>
    );

    warningBlock = (
      <small>
        <div className="text-danger text-center mt-3" role="alert">
          <i className="fas fa-exclamation-triangle"></i> You will need to
          re-enter the link once the progress bar runs out.
        </div>
      </small>
    );
  } else {
    whenBlock = (
      <div className="mt-3 mb-3">
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-exclamation-triangle"></i> This link cannot be
          used again. Please, save its content in a secure place.
        </div>
      </div>
    );

    warningBlock = (
      <small>
        <div className="text-danger text-center mt-3" role="alert">
          <i className="fas fa-exclamation-triangle"></i> This secret will
          expire once the progress bar runs out.
        </div>
      </small>
    );
  }

  return (
    <>
      {opened}
      {description}

      <div className="mb-3">
        <i className="fas fa-check-circle"></i> You can grab the content
        delivered.
      </div>

      <div className="mb-3">
        <div className="row">
          <div className="col-6">
            <button
              id="showHideMessageBtn"
              onClick={revealData}
              className="btn btn-primary form-control"
              type="button"
              data-toggle="collapse"
              data-target="#collapseMessage"
              aria-expanded="false"
              aria-controls="collapseMessage"
            >
              {btnRevealContent}
            </button>
          </div>

          <div className="col-6">
            <button
              className="btn form-control btn-outline-primary"
              type="button"
              disabled={btnDisabled}
              onClick={copyToClipboard}
            >
              {btnCopyContent}
            </button>
          </div>
        </div>
      </div>

      <div id="collapseMessage" className="input-group collapse">
        <div className="input-group">
          {/*<ReactJson src=secret name={false} />*/}
          <Form 
            schema={schemaMain} 
            uiSchema={uiSchema} 
            validator={validator} 
            templates={{ ButtonTemplates: { MoveUpButton, MoveDownButton, AddButton, RemoveButton } }}
            readonly
          />
        </div>
      </div>

      {whenBlock}
      <div id="sharepass-progressbar-timer"></div>
      {warningBlock}
    </>
  );
}

export default CustomSchemaTemplate;
